import * as React from 'react'
// import { Close } from 'svgIcons'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import { mobileBreakPoint } from 'app.styled/media'
import ScrapWarning from 'svgIcons/ScrapWarning'

type TProps = {
  onClick: () => void
}

const NewsCardItemDeleted: React.FC<TProps> = ({ onClick }) => {
  return (
    <StyledWrapper>
      <div className="lt">
        <div className="warning">
          <ScrapWarning />
        </div>
        <div className="content">삭제된 소식입니다.</div>
      </div>
      <div className="rt">
        <a onClick={onClick}>
          <Close className="close-btn" />
        </a>
      </div>
    </StyledWrapper>
  )
}

export default NewsCardItemDeleted

const StyledWrapper = styled.div`
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  align-items: center;
  > .lt {
    display: flex;
    gap: 28px;
    overflow: hidden;
    align-items: center;
    .warning {
      width: 66px;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .content {
      color: #999999;
    }
  }
  > .rt {
    padding: 20px;
  }

  .close-btn {
    width: 16px;
    height: 16px;
    fill: #333;
  }

  ${mobileBreakPoint} {
    > .lt {
      padding-left: 20px;
      gap: 10px;
    }
  }
`
